import { has, isString } from 'lodash'
import { BaseLoginOutput, isBaseLoginOutput } from './base-login-output.model'

export interface RedirectOutput extends BaseLoginOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  UrlRedirect: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRedirectOutput = (output: any): output is RedirectOutput =>
  isBaseLoginOutput(output) && has(output, 'UrlRedirect') && isString(output['UrlRedirect'])
